import "./LbsSelect.css";
import React, { useState, useEffect } from "react";
import API from "../library/ApiManager";
import { v4 as uuidv4 } from "uuid";
import Fnc from "../library/Functions";
import { useRef } from "react";
import InlineFieldLoader from './InlineFieldLoader';

function LbsSelect(props) {
	const [loading, setLoading] = useState(null);
	const [typed, setTyped] = useState("");
	const [dropdownList, setDropdownList] = useState([]);
	const [showError, setShowError] = useState(false);
	const [uuidList] = useState(() => uuidv4());
	const [errorMsg, setErrorMsg] = useState(null);
	const [active, setActive] = useState(0);
	const elmChoosedRef = useRef(Boolean(props.value));
	const requestSequenceRef = useRef(0);
	//const [eventSource, setEventSource] = useState(null);
	const useFocus = () => {
		const htmlElRef = useRef(null)
		const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }

		return [htmlElRef, setFocus]
	}
	const [inputRef, setInputFocus] = useFocus();

	const addType = "address";

	//const [, updateState] = React.useState();
	//const forceUpdate = React.useCallback(() => updateState({}), []);

	useEffect(() => {
		// Similar to componentDidMount and componentDidUpdate:
		setTyped(props.value);
		elmChoosedRef.current = Boolean(props.value);
	}, [props.forceDisabled, props.value]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

	useEffect(() => () => { requestSequenceRef.current += 1; }, []);

	useEffect(() => {
		if (props.setFocus) {
			setInputFocus();
		}

	}, [props.setFocus]);

	function onInputChanged(e) {
		//if (eventSource !== 'list') {
		let val = e.target.value;

		if (props.type === addType
				&& (!props.preAppendVal || props.preAppendVal.trim().length === 0)) {
			setTyped("");
			setDropdownList([]);
			setLoading(false);
			elmChoosedRef.current = false;
			props.callback(new Fnc.Ret(Fnc.EnmGen.NOT_SELECTED));
			return;
		}

		setTyped(val);
		elmChoosedRef.current = false;

		if (val && val.length > 0) {
			setLoading(true);
			setDropdownList([]);
			const requestSequence = ++requestSequenceRef.current;

			//------ configurazioni particolari impostazioni chiamata LBS 
			let opentipo = 0; //city
			if (props.type === addType) {
				opentipo = -1;
			}

			let valApi = props.preAppendVal && props.preAppendVal.length > 0 ? props.preAppendVal + " " + val : val;

			//-----
			API.lbs(valApi, opentipo, (data) => {
				if (requestSequence !== requestSequenceRef.current) return;
				if (data && data.r) {
					// ------ Filtriamo gli elementi per escludere quelli vuoti o che non sono perfettamente corrispondenti
					// let dataOk = data.r.filter(function (el) {
					//   let v = props.type === addType ? el.topo : el.com;
					//   return v && v.length > 0 && v.toLowerCase().includes(val.toLowerCase());
					// }).slice(0, 6);

					let dataOk = data.r
						.filter(function (el) {
							let v = props.type === addType ? el.topo : el.com;
							return v && v.length > 0;
						})
						.slice(0, 6);

					var retVals = dataOk.map((elm) => ({
						// required: what to show to the user
						label: props.type === addType ? elm.topo : (elm.fraz ? elm.fraz + ", " : "") + elm.com + " (" + elm.prov + ")",
						// required: key to identify the item within the array
						key: elm.cod,
						elm: elm,
					}));
					/*retVals.sort(function (a, b) {
						if (a.label < b.label) {
							return -1;
						}
						if (a.label > b.label) {
							return 1;
						}
						return 0;
					});*/
					setDropdownList(retVals);
					//forceUpdate();
				}
				setLoading(false);
			});
		} else {
			requestSequenceRef.current += 1;
			setLoading(false);
			setDropdownList([]);
			props.callback(new Fnc.Ret(Fnc.EnmGen.KO));
		}
		//}
	}

	function onElmSelect(e) {
		let key = e.currentTarget.getAttribute("data-option-id");

		jobSelect(key);
	}

	function jobSelect(key) {

		if (key && key.length > 0) {
			//ho un elemento selezionato

			let selElm = dropdownList.find(function (el) {
				return el.key.toString().toLowerCase() === key.toLowerCase();
			});
			if (selElm) {
				Fnc.log("SELECTED", selElm, Fnc.LogLvl.DEBUG);
				setShowError(false);
				setErrorMsg(null);
				elmChoosedRef.current = true;
				props.callback(new Fnc.Ret(Fnc.EnmGen.OK, selElm));
				setTyped(selElm.label);
			} else {
				setShowError(true);
				setErrorMsg(Fnc.EnmGen.KO.msg);
				props.callback(new Fnc.Ret(Fnc.EnmGen.KO));
			}

			setDropdownList([]);

		} else {
			//NON ho un elemento selezionato
			setShowError(false);
			setErrorMsg(null);
			props.callback(new Fnc.Ret(Fnc.EnmGen.OK, null));
		}
	}

	function chiusuratendina(e) {
		setDropdownList([]);
		if (!elmChoosedRef.current) {
			setShowError(true);
			setErrorMsg(Fnc.EnmGen.NOT_SELECTED.msg);
			props.callback(new Fnc.Ret(Fnc.EnmGen.NOT_SELECTED));
		}
	}

	const SelectLbs = useRef(null);
	const scrollTop = (ref) => {
		if (props.enablescroll) {
			if (window.innerWidth < 640) {
				window.scrollTo({
					top: SelectLbs.current.offsetTop + 50,
					behavior: 'smooth',
				});
			}
		};
	}

	function onKeyUp(event) {
		if (props.callbackKeyboard) {
			props.callbackKeyboard(event.keyCode);
		}
	}


	function onKeyDown(e) {
		if (e.keyCode === 13) {
			e.preventDefault();
			// enter key
			if (dropdownList.length > 0 && active >= 0 && active < dropdownList.length) {
				let key = dropdownList[active].key + "";
				jobSelect(key);
			} else {
				//ha schiacciato enter con un valore valido senza tendina
				elmChoosedRef.current = true;
				props.callback(new Fnc.Ret(Fnc.EnmGen.OK, null));
			}
			setActive(0);
		} else if (e.keyCode === 38) {
			// up arrow
			if (active > 0) {
				setActive(active - 1);
			}
		} else if (e.keyCode === 40) {
			// down arrow
			if (active < dropdownList.length - 1) {
				setActive(active + 1);
			}
		}
		else { setActive(0); }
	};

	return (

		<div className={`iol-autocomplete ${props.forceDisabled === true ? "iol-autocomplete--disabled" : ""}`}>
			<div className="iol-autocomplete__field" ref={SelectLbs}>
				<input 
					id={`${uuidList}-input`}
					type="text" 
					placeholder={props.type === addType ? "Es. Via Roma 10" : "Es. Milano"}
					className={`form-control ${props.forceDisabled === true ? "disabled" : ""} ${showError ? "iol-field--error" : ""}`}
					role="combobox"
					aria-labelledby={`${uuidList}-label`}
					aria-controls={uuidList}
					aria-expanded={dropdownList.length > 0}
					aria-autocomplete="list"
					aria-busy={Boolean(loading)}
					aria-invalid={showError}
					aria-activedescendant={dropdownList.length > 0 ? `${uuidList}-option-${active}` : undefined}
					disabled={props.forceDisabled} 
					autoComplete="off"
					onClick={() => scrollTop(SelectLbs)}
					onBlur={chiusuratendina}
					onChange={onInputChanged}
					value={typed || ""}
					ref={inputRef}
					onKeyUp={onKeyUp} 
					onKeyDown={onKeyDown}/>
				  <span className={`placeholder-text ${showError ? "lblError" : ""} ${props.forceDisabled === true ? "disabled" : ""}`} id={`${uuidList}-label`}>
					{(/^\*\s*/.test(props.label || "") || props.required) && <span className="checkout-required-marker" aria-hidden="true">*</span>} {(props.label || "").replace(/^\*\s*/, "")}
				  </span>
				  <InlineFieldLoader visible={loading} label={`Ricerca ${props.type === addType ? "indirizzo" : "comune"} in corso`} />
					
			</div>
			{showError && <div className="iol-error-label" role="alert">{errorMsg}</div>}
			<div className="iol-autocomplete__results">
					<ul className={`iol-autocomplete__list ${dropdownList.length > 0 ? "is-open" : ""}`} id={uuidList} role="listbox">
						{dropdownList.map((item, index) => (
							<li id={`${uuidList}-option-${index}`} key={item.key}
								className={`iol-autocomplete__option ${index === active ? "activeul" : ""}`}
								role="option" aria-selected={index === active} data-option-id={item.key}
								onMouseEnter={() => setActive(index)} onMouseDown={onElmSelect}>
								<span className={`iol-autocomplete__icon iol-autocomplete__icon--${props.type === addType ? "address" : "city"}`} aria-hidden="true"></span>
								<span className="iol-autocomplete__option-text">{item.label}</span>
							</li>
						))}
					</ul>
			</div>
		</div>
	);
}

export default LbsSelect;
